import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function ShareIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="ShareIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path
                id="Trazado_1823"
                d="M314.679,676.282a.96.96,0,0,1,1.36,0l2.885,2.885a.961.961,0,0,1-1.36,1.36l-1.243-1.243V688.5a.962.962,0,0,1-1.923,0v-9.217l-1.243,1.243a.961.961,0,0,1-1.36-1.36Zm-7.013,8.372a1.923,1.923,0,0,1,1.923-1.923h1.923a.962.962,0,1,1,0,1.923H309.59v8.654h11.538v-8.654h-1.923a.962.962,0,0,1,0-1.923h1.923a1.923,1.923,0,0,1,1.923,1.923v8.654a1.923,1.923,0,0,1-1.923,1.923H309.59a1.923,1.923,0,0,1-1.923-1.923Z"
                transform="translate(-307.667 -676)"
                fill="#e6ba0e"
            />
        </SvgIcon>
    );
}
